import Marionette from "backbone.marionette";
/////VISTA Informe Resumenes
import LogsTpl from "views/logs/logsView.ejs";
import LineTpl from "views/logs/formLine.ejs";
import GoodDetailLogs from "views/logs/logsViewDetail.js";

import Moment from "moment";

import CSS from "views/logs/logs.css";

import PaginationView from "views/pagination/pagination.js";
import LogModel from "models/logsModel.js";
import FiltersModel from "models/filtersModel.js";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({


    initialize: function(data) {
        ////this.listenTo(this.collection, "sync", this.applyView.bind(this));

        this.model = new LogModel();

        this.listenTo(this.collection, "sync", this.applyView.bind(this));

        this.listenTo(S.mApp, "next", this.next.bind(this));
        this.listenTo(S.mApp, "prev", this.prev.bind(this));
        this.listenTo(S.mApp, "page", this.page.bind(this));

        var filtersModel = new FiltersModel();      
        filtersModel.fetch({
            data: {
                page: "logs",
            },
            beforeSend: T.useToken,
            success: function() {
                // Pre filters
                this.filters = filtersModel.toJSON();
            }.bind(this)
        });        

    },

    template: LogsTpl,

    render: function() {
        $("#loaderContainer").show();
        this.collection.reset();
        this.collection.fetch({
            data: {
                instanceId: S.instanceId,
                page: 1
            },
            beforeSend: T.useToken,
            success: function() {
                this.$el.html(this.template({
                    lang: this.collection.lang
                }));
            }.bind(this)
        });
    },
    applyView: function() {

        if(_.isEmpty(this.filters)){  
            $("#lines").html(""); // Empty filters container                      
            $("#lines").append(LineTpl({                 
                filters: "", 
                desc: this.collection.desc,
                lang: this.collection.lang,
                showremove: false 
            }));
        } else {
            $("#lines").html(""); // Empty filters container
            var showit = false;
            for (var f in this.filters) {
                $("#lines").append(LineTpl({                     
                    filters: this.filters[f], 
                    desc: this.collection.desc,
                    lang: this.collection.lang,
                    showremove: showit 
                }));
                showit = true;
            }
        }        

        var data = [];
        var buttonAvailableV = '<div class="unbreakable">' +
        '<span class="ion ion-ios-eye text-light-blue viewLogs_ID"></span></div>';

        _.each(this.collection.models, function(model) {

            var lang = this.collection.lang;


            var strin_operaci_atrri = '';
            $.each(model.attributes.Newvalue, function(indexVal, valueVal) {
                strin_operaci_atrri += " " + indexVal + " :" + valueVal + ",";
            });

            var operacion;
            switch (model.attributes.operacion) {
                case "create":
                    operacion = '<span class="label label-success">' + model.attributes.operacion + '</span>';
                    break;
                case "update":
                    operacion = '<span class="label label-warning">' + model.attributes.operacion + '</span>';
                    break;
                case "delete":
                    operacion = '<span class="label label-danger">' + model.attributes.operacion + '</span>';
                    break;
            }

            data.push({
                id: model.attributes.id,
                itemId: model.attributes.itemId,
                name: model.attributes.name,
                operacion: operacion,
                usuariomodificador: model.attributes.usuariomodificador,
                fecha_modificado: model.attributes.fecha_modificado,
                tipocambio: model.attributes.tipocambio,
                action: buttonAvailableV
            });
        }.bind(this));

        $("#listsData").bootstrapTable({
            striped: true,
            uniqueId: 'id',
            columns: [{
                    field: 'itemId',
                    title: 'Id',
                    sortable: true
                }, {
                    field: 'name',
                    title: this.collection.lang.ENTIDAD,
                    sortable: true
                }, {
                    field: 'operacion',
                    title: this.collection.lang.ACTION,
                    sortable: true
                },
                /*{
                    field: 'newvalor',
                    title: this.collection.lang.NEW_VALUE,
                    sortable: true
                }, {
                    field: 'oldvalor',
                    title: this.collection.lang.OLD_VALUE,
                    sortable: true
                },*/
                {
                    field: 'usuariomodificador',
                    title: this.collection.lang.MODIFICADO_POR,
                    sortable: true
                }, {
                    field: 'fecha_modificado',
                    title: this.collection.lang.LAST_MODIFICATION,
                    sortable: true
                }, {
                    field: 'tipocambio',
                    title: this.collection.lang.TYPE_MODIFICATION,
                    sortable: true
                }, {
                    field: 'action',
                    title: '',
                }
            ]
        });

        $("#listsData").bootstrapTable("removeAll");
        $("#listsData").bootstrapTable("append", data);


        $("#listsData").off("sort.bs.table").on("sort.bs.table", function(ev, $param1, $param2) {
            var page = parseInt($(".pagination li.active").attr("id").split("-")[1]);

            this.searchService(page, {
                column: $param1,
                order: $param2
            });
        }.bind(this));

        this.pagination.show(new PaginationView({
            attributes: this.collection.pageAttributes
        }));

        $("#wrapper").height(window.innerHeight);

        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        // Not apply on start
        // this.adjustForm();

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li").removeClass("menu-open");
        $(".sidebar li > ul").removeClass("menu-open").css("display","none");
        // Add active menu items
        $("#LOGS").parent().addClass("active");
        
        $("#loaderContainer").hide();

    },
    events: {
        "click .searchButton.add": "addLine",
        "click .searchButton.remove": "removeLine",
        "submit #searchForm": "submit",
        "click #removeFilter": "removeFilter",
        "change #fieldname": "adjustForm",
        "click .viewLogs_ID": "viewLogGood",
    },
    addLine: function(ev) {
        var operator = $(ev.target).parents(".formLine").find("#operator");
        if (operator.val() === "--")
            operator.val("and");

        $("#lines").append(LineTpl({
            filters: "",            
            lang: this.collection.lang,
            showremove: true
        }));  

        //Date controls
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        this.adjustForm();

    },
    removeLine: function(ev) {
        $(ev.target).parents(".formLine").remove();
    },
    submit: function(ev) {
        ev.preventDefault();
        var request = {};
        var data = [];
        var newFilters = [];
        $.each($(".formLine"), function() {
            var line = {};
            line.fieldname = $(this).find("#fieldname").val();
            line.nbcomparador = $(this).find(".operator:visible").val();
            line.value = $(this).find(".value:visible").val();
            line.operator = $(this).find("#operator").val();
            line.operator === "--" ? "" : line.operator;
            line.nbfield = $(this).find(".operator:visible").attr("id");
            line.valuefield = $(this).find(".value:visible").attr("id");
            if(line.fieldname) { 
                data.push(line);
                newFilters.push(line);
            }
        });

        this.filters = newFilters;
        request.instanceId = S.instanceId;
        request.data = data;
        request.page = 1;

        this.model.save(request, {
            beforeSend: T.useToken,
            success: function() {

                this.collection.set(this.model.attributes._embedded);
                //Update page attributes as well
                this.collection.pageAttributes = {
                    page: this.model.attributes.page,
                    page_count: this.model.attributes.page_count,
                    page_size: this.model.attributes.page_size,
                    total_items: this.model.attributes.total_items
                };
                this.applyView();

            }.bind(this)
        });


    },
    searchService: function(page, params, resetFilters) {

        var data = {};
        var searchItems = $(".search");

        $.each(searchItems, function() {
            if ($(this).val())
                data[$(this).attr("name")] = $(this).val();
        });

        data.page = page || 1;
        data.instanceId = S.instanceId;
        data.resetFilters= resetFilters;

        if (params && params.column) {
            data.column = params.column;
            data.order = params.order;
        }

        this.collection.fetch({
            data: data,
            beforeSend: T.useToken,
            instanceId: S.instanceId
        });
        this.applyView();
    },

    adjustForm: function() {

        $(".formLine").each(function() {
            var selector = $(this).find("#fieldname");
            $(this).find("#operatorHolder select").addClass("hidden");
            $(this).find("#valueHolder > *").addClass("hidden");

            switch (selector.val()) {

                case "operacion":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#tipeOperaci").removeClass("hidden");
                    break;
                case "fecha_modificado":
                    $(this).find("#nbcomparador").removeClass("hidden");
                    $(this).find("#dtpickerBuscar").removeClass("hidden");
                    break;
                case "entity":
                    $(this).find("#nbIgual").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");
                    break;
                case "usuariomodificador":
                    $(this).find("#nbIncluye").removeClass("hidden");
                    $(this).find("#textValue").removeClass("hidden");                    
                    break;
                case "tipocambio":
                    $(this).find("#nbIgual").removeClass("hidden");                    
                    $(this).find("#typeCambio").removeClass("hidden");
                    break;
                default:
                $(this).find("#nbIgual").removeClass("hidden");
                $(this).find("#textValue").removeClass("hidden");                    

            }
        });
    },

    viewLogGood: function(ev) {
        ev.preventDefault();
        var good_id = $(ev.currentTarget).parents("tr").attr("data-uniqueid");        
        S.mApp.trigger("modal", {
            view: new GoodDetailLogs({
                model: this.collection.get(good_id),
                id: good_id,
                lang: this.collection.lang,
                instanceId: S.instanceId
            })
        });
    },
    removeFilter: function() {
        this.filter = 0;        
        // Reset filters
        this.filters = "";
        $("#lines").html(""); // Empty filters container              
        this.searchService(1, this.params, true);
    },
    next: function(ev) {
        var nextPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) + 1;
        this.searchService(nextPage,this.params, false);
    },
    prev: function(ev) {
        var prevPage = parseInt($(".pagination li.active").attr("id").split("-")[1]) - 1;
        this.searchService(prevPage,this.params, false);
    },
    page: function(ev) {
        var page = parseInt($(ev.target).parent().attr("id").split("-")[1]);
        this.searchService(page,this.params, false);
    },
    regions: {
        pagination: "#paginationHolder"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/logs/logsView.js
// module id = 191
// module chunks = 0